<template>
  <v-switch label="AgGrid" v-model="showAg" @change="onChange" dense></v-switch>
</template>

<script>
import EventBus from "../../../store/event-bus";
export default {
  name: "ag-grid-switch",

  props: {
    name: {
      type: String,
      default: () => "",
    },
  },

  data() {
    return {
      showAg:
        this.name != ""
          ? this.$store.getters.localSettings(`${this.name}-showAg`, false)
          : false,
    };
  },

  methods: {
    onChange() {
      this.$store.dispatch("updateLocalSettings", {
        [`${this.name}-showAg`]: this.showAg,
      });
      EventBus.$emit("show-ag-grid", { [`${this.name}-showAg`]: this.showAg });
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/shared/AgGridSwitch.vue